import { Injectable } from '@angular/core';

export interface MapPreferences {
  selectedMapType: string;
  showEvacuationRadius: boolean;
  showPendingEvents: boolean;
  showCompletedEvents: boolean;
  showEventsOutsideView: boolean;
}

const STORAGE_KEY = 'mapPreferences';

const defaults: MapPreferences = {
  selectedMapType: 'streets',
  showEvacuationRadius: false,
  showPendingEvents: true,
  showCompletedEvents: true,
  showEventsOutsideView: true,
};

@Injectable({ providedIn: 'root' })
export class MapPreferencesService {
  load(): MapPreferences {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return { ...defaults, ...JSON.parse(stored) };
      }
    } catch {}
    return { ...defaults };
  }

  save(prefs: MapPreferences): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  }
}
